import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdminPanelUserHistoryEntry } from '../../../../../../../shared/models/admin-panel-user-history-entry';
import { UserEventObject } from '../../../../../../../shared/enums/user-event-object.enum';
import { UserEventType } from '../../../../../../../shared/enums/user-event-type.enum';
import { getUserEventBusinessLabel } from '../../../../../../../shared/constants/user-event-business-label-map';
import { HistoryEventDetailsComponent } from '../../../../../../../shared/components/history-event-details/history-event-details.component';
import { ConstLabelReaderPipe } from '../../../../../../../shared/pipes/const-label-reader.pipe';

@Component({
  selector: 'app-admin-panel-user-event-details-dialog',
  imports: [Button, Card, ConstLabelReaderPipe, DatePipe, HistoryEventDetailsComponent],
  templateUrl: './admin-panel-user-event-details-dialog.component.html',
  styleUrl: './admin-panel-user-event-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserEventDetailsDialogComponent {
  event = input.required<AdminPanelUserHistoryEntry>();

  protected readonly dialogRef = inject(DynamicDialogRef);
  protected readonly getUserEventBusinessLabel = getUserEventBusinessLabel;
  protected readonly USER_EVENT_OBJECT = UserEventObject;
  protected readonly USER_EVENT_TYPE = UserEventType;

  protected getEventTypeLabel(): string {
    const eventType = this.event().eventType;
    const businessLabel = getUserEventBusinessLabel(eventType);
    const technicalLabel = UserEventType[eventType] ?? '';

    return businessLabel !== technicalLabel
      ? `${businessLabel} (${technicalLabel})`
      : businessLabel;
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
